// components/PublicNavbar.jsx

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./PublicNavbar.css";

export default function PublicNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.getElementById("mainNav");
      nav?.classList.toggle("scrolled", window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
  }, [mobileOpen]);

  return (
    <>
      <nav className="navi" id="mainNav">
              <Link to="/talentintro" className="nav-logo">
                <img
                  src="https://cdn.shopify.com/s/files/1/0712/5755/5236/files/logo.02a8dd85ba2d3d75511a.png"
                  alt="DirectSubmit"
                />
              </Link>
      
              <div className="nav-links">
      <a href="/casting-calls">Casting Calls</a>
      
                <Link to="/director-tour">
                  Post Casting Notice
                </Link>
              </div>
      
              <div className="nav-ctas">
                <Link to="/login" className="btn-ghost">
                  Log In
                </Link>
      
                <Link to="/signup" className="btn-primary">
                  Join Now
                </Link>
              </div>
      
              <button
                className={`nav-hamburger ${mobileOpen ? "open" : ""}`}
                onClick={() => setMobileOpen(!mobileOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </nav>
      
            <div className={`mobile-nav ${mobileOpen ? "open" : ""}`}>
      <a href="/casting-calls">Casting Calls</a>
      
              <Link to="/director-tour">
                Post Casting Notice
              </Link>
      
              <div className="mobile-nav-ctas">
                <Link to="/login" className="btn-ghost">
                  Log In
                </Link>
      
                <Link to="/signup" className="btn-primary">
                  Join Now
                </Link>
              </div>
            </div>
    </>
  );
}